/*
 * Product Image ScrollTo Interaction
 *
 **/

import 'slick-carousel';

custom.projectIndexCarousel = (() => {
  const blockClass = 'js-project-index-carousel';

  const imgConfig = {
    infinite: true,
    dots: true,
    arrows: true,
    fade: true,
  };

  function init() {
    if ($(`.${blockClass}`).length > 0) {
      $.each($(`.${blockClass}`), (index, el) => {
        $(el).slick(imgConfig);
      });
    }
  }

  return {
    init: init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/project-index-carousel.js